import authService from "../auth.js";



const authProvider = {
  // called when the user clicks on the logout button
  logout: async () => {
    const user = await authService.getUser();
    const id_token = user?.id_token;
    localStorage.clear();
    if (id_token) {
      return authService.logout({ id_token_hint: id_token });
    } else {
      return authService.logout();
    }
  },

  // called when the user navigates to a new location, to check for authentication
  checkAuth: () => {
    if (localStorage.getItem("isLoggedIn") === "true") {
      return Promise.resolve();
    } else {
      return Promise.reject();
    }
  },
  // called when the user navigates to a new location, to check for permissions / roles
  getPermissions: () => Promise.resolve(),
};

export default authProvider;
